// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Support Management */
.support-management-page .dashboard-body {
  padding-bottom: 2rem;
}

.support-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.support-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.support-stat-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.support-stat-card__value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.support-stat-card__label {
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
}

.support-stat-card--open .support-stat-card__value {
  color: #ea580c;
}

.support-stat-card--resolved .support-stat-card__value {
  color: #16a34a;
}

.support-stat-card--closed .support-stat-card__value {
  color: #dc2626;
}

.support-list-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.support-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.support-list-header__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.support-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted, #64748b);
}

.support-page-limit__select {
  min-width: 88px;
  padding: 0.45rem 0.65rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: var(--text, #1e293b);
  cursor: pointer;
}

.support-page-limit__select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.support-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.support-pagination__info {
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
}

.support-pagination__buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.support-pagination__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.support-pagination__btn:hover:not(:disabled) {
  background: #f0fdfa;
  border-color: #0f766e;
}

.support-pagination__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.support-list__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.support-list__title i {
  color: #0f766e;
}

.support-btn-export {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.support-btn-export:hover {
  opacity: 0.95;
}

.support-table-wrap {
  overflow-x: auto;
}

.support-empty {
  padding: 3rem 1.5rem;
  text-align: center;
  color: var(--text-muted, #64748b);
}

.support-empty i {
  font-size: 2.5rem;
  display: block;
  margin-bottom: 0.75rem;
  opacity: 0.6;
}

.support-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.support-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #f0f9ff;
  background: rgba(15, 23, 42, 0.85);
  white-space: nowrap;
}

.support-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text, #1e293b);
}

.support-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.support-table tbody tr:hover {
  background: rgba(139, 92, 246, 0.08) !important;
}

.support-seen {
  color: var(--text-muted, #64748b);
}

.support-unseen {
  font-weight: 600;
  color: var(--text, #1e293b);
}

.support-text-cell {
  max-width: 200px;
}

.support-read-more {
  display: inline-block;
  margin-left: 0.35rem;
  padding: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: #0f766e;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
}

.support-no-image {
  color: var(--text-muted, #64748b);
  font-size: 0.85rem;
}

.support-img-link {
  color: #0f766e;
  text-decoration: none;
}

.support-img-link:hover {
  text-decoration: underline;
}

.support-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.7rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 700;
}

.support-status-badge--open {
  background: #fef3c7;
  color: #b45309;
}

.support-status-badge--resolved {
  background: #dcfce7;
  color: #166534;
}

.support-status-badge--closed {
  background: #fef2f2;
  color: #b91c1c;
}

.support-status-dot {
  font-size: 0.4rem;
  vertical-align: middle;
}

.support-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.support-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.support-action-btn:hover {
  opacity: 0.9;
}

.support-action-btn--close {
  background: #dc2626;
  color: #fff;
}

.support-action-btn--resolve {
  background: #16a34a;
  color: #fff;
}

.support-action-btn--chat {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.support-actions-closed {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.support-actions-status-text {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
}

.support-actions-status-text--resolved {
  background: #dcfce7;
  color: #166534;
}

.support-actions-status-text--closed {
  background: #fef2f2;
  color: #b91c1c;
}

/* Modals */
.support-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.support-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.support-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.support-modal-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.support-modal-close {
  padding: 0.35rem;
  font-size: 1.1rem;
  color: #64748b;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 6px;
}

.support-modal-close:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.support-modal-body {
  padding: 1.25rem;
  overflow-y: auto;
  flex: 1 1;
}

.support-modal-text {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.support-chat-placeholder {
  margin: 0;
  color: var(--text-muted, #64748b);
  font-size: 0.9rem;
}

.support-modal-footer {
  padding: 1rem 1.25rem;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.support-modal-btn-close {
  padding: 0.5rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: #475569;
  background: #f1f5f9;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.support-modal-btn-close:hover {
  background: #e2e8f0;
}

@media (max-width: 1024px) {
  .support-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .support-stats {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Support/SupportManagementPage.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Support Management */\n.support-management-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.support-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.support-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.support-stat-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.support-stat-card__value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.support-stat-card__label {\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n}\n\n.support-stat-card--open .support-stat-card__value {\n  color: #ea580c;\n}\n\n.support-stat-card--resolved .support-stat-card__value {\n  color: #16a34a;\n}\n\n.support-stat-card--closed .support-stat-card__value {\n  color: #dc2626;\n}\n\n.support-list-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.support-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.support-list-header__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.support-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted, #64748b);\n}\n\n.support-page-limit__select {\n  min-width: 88px;\n  padding: 0.45rem 0.65rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text, #1e293b);\n  cursor: pointer;\n}\n\n.support-page-limit__select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.support-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.support-pagination__info {\n  font-size: 0.875rem;\n  color: var(--text-muted, #64748b);\n}\n\n.support-pagination__buttons {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.support-pagination__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.support-pagination__btn:hover:not(:disabled) {\n  background: #f0fdfa;\n  border-color: #0f766e;\n}\n\n.support-pagination__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.support-list__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.support-list__title i {\n  color: #0f766e;\n}\n\n.support-btn-export {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.support-btn-export:hover {\n  opacity: 0.95;\n}\n\n.support-table-wrap {\n  overflow-x: auto;\n}\n\n.support-empty {\n  padding: 3rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n}\n\n.support-empty i {\n  font-size: 2.5rem;\n  display: block;\n  margin-bottom: 0.75rem;\n  opacity: 0.6;\n}\n\n.support-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.support-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #f0f9ff;\n  background: rgba(15, 23, 42, 0.85);\n  white-space: nowrap;\n}\n\n.support-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text, #1e293b);\n}\n\n.support-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.support-table tbody tr:hover {\n  background: rgba(139, 92, 246, 0.08) !important;\n}\n\n.support-seen {\n  color: var(--text-muted, #64748b);\n}\n\n.support-unseen {\n  font-weight: 600;\n  color: var(--text, #1e293b);\n}\n\n.support-text-cell {\n  max-width: 200px;\n}\n\n.support-read-more {\n  display: inline-block;\n  margin-left: 0.35rem;\n  padding: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #0f766e;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.support-no-image {\n  color: var(--text-muted, #64748b);\n  font-size: 0.85rem;\n}\n\n.support-img-link {\n  color: #0f766e;\n  text-decoration: none;\n}\n\n.support-img-link:hover {\n  text-decoration: underline;\n}\n\n.support-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.35rem 0.7rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.support-status-badge--open {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.support-status-badge--resolved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.support-status-badge--closed {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.support-status-dot {\n  font-size: 0.4rem;\n  vertical-align: middle;\n}\n\n.support-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.support-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.7rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.support-action-btn:hover {\n  opacity: 0.9;\n}\n\n.support-action-btn--close {\n  background: #dc2626;\n  color: #fff;\n}\n\n.support-action-btn--resolve {\n  background: #16a34a;\n  color: #fff;\n}\n\n.support-action-btn--chat {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.support-actions-closed {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.support-actions-status-text {\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.35rem 0.65rem;\n  border-radius: 6px;\n}\n\n.support-actions-status-text--resolved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.support-actions-status-text--closed {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n/* Modals */\n.support-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.support-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.support-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.support-modal-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.support-modal-close {\n  padding: 0.35rem;\n  font-size: 1.1rem;\n  color: #64748b;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.support-modal-close:hover {\n  background: #e2e8f0;\n  color: #1e293b;\n}\n\n.support-modal-body {\n  padding: 1.25rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.support-modal-text {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.support-chat-placeholder {\n  margin: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 0.9rem;\n}\n\n.support-modal-footer {\n  padding: 1rem 1.25rem;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.support-modal-btn-close {\n  padding: 0.5rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #475569;\n  background: #f1f5f9;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.support-modal-btn-close:hover {\n  background: #e2e8f0;\n}\n\n@media (max-width: 1024px) {\n  .support-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .support-stats {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
